<script setup>

import Card from "@/Components/Card.vue";
import Arrow from "@/Components/Icons/Arrow.vue";
import {ref} from "vue";

const props = defineProps({
    title: String,
    description: String,
    isBuyer: {
        type: Boolean,
        default: false
    }
})

const openBlock = ref(false)

const open = () => {
    if (props.isBuyer) {
        openBlock.value = !openBlock.value
    }
}


</script>

<template>
    <card class="p-3 flex flex-col gap-2.5">
        <div class="px-2.5 dark:text-slate-200 text-sm font-medium leading-full uppercase">
            {{ title }}
        </div>
        <div class="flex" :class="{'cursor-pointer': isBuyer}" @click="open">
            <div :class="isBuyer && !openBlock ? 'h-4': 'h-auto'"
                 class="dark:text-slate-200 text-sm font-normal leading-120 tracking-wider items-center overflow-hidden uppercase whitespace-pre-wrap">
                {{ description }}
            </div>

            <template v-if="isBuyer">
                <Arrow class="shrink-0 -mt-1"/>
            </template>
        </div>
    </card>
</template>

<style scoped>

</style>
